module.exports = __webpack_public_path__ + "images/emoji/put_litter_in_its_place.a76850232560aff73ef3.png";